(function () {
  function qsAll(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function updateNavMeasurements() {
    var header = document.querySelector('.header-wrapper, sticky-header.header-wrapper, .section-header .header-wrapper');
    var nav = document.querySelector('[class*="mega-nav-section-"]');
    if (!header || !nav) return;
    var headerRect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--innernerd-nav-top', Math.max(0, Math.round(headerRect.bottom)) + 'px');
    document.documentElement.style.setProperty('--innernerd-nav-height', Math.round(nav.getBoundingClientRect().height || 0) + 'px');
  }

  function fitMegaDropdown(item) {
    var dropdown = item && item.querySelector('.mega-menu-dropdown');
    if (!dropdown) return;
    item.classList.remove('mega-align-right', 'mega-align-left');
    window.requestAnimationFrame(function () {
      var rect = dropdown.getBoundingClientRect();
      if (rect.right > window.innerWidth - 12) item.classList.add('mega-align-right');
      if (rect.left < 12) item.classList.add('mega-align-left');
    });
  }

  function bindMegaDropdowns() {
    qsAll('[class*="mega-nav-section-"] .mega-nav-item').forEach(function (item) {
      if (item.dataset.srPhase3MegaBound === 'true') return;
      item.dataset.srPhase3MegaBound = 'true';
      item.addEventListener('mouseenter', function () { fitMegaDropdown(item); });
      item.addEventListener('focusin', function () { fitMegaDropdown(item); });
    });
  }

  function bindAccountMenu() {
    qsAll('.tm_header-dropdown').forEach(function (dropdown) {
      if (dropdown.dataset.srPhase3AccountBound === 'true') return;
      dropdown.dataset.srPhase3AccountBound = 'true';
      var trigger = dropdown.querySelector('.user-background');
      var menu = dropdown.querySelector('.my-account');
      if (!trigger || !menu) return;

      function open() {
        dropdown.classList.add('active');
        trigger.setAttribute('aria-expanded', 'true');
        menu.style.removeProperty('display');
      }

      function close() {
        dropdown.classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
        menu.style.removeProperty('display');
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (dropdown.classList.contains('active')) close();
        else open();
      });

      dropdown.addEventListener('mouseenter', open);
      dropdown.addEventListener('mouseleave', function () {
        window.setTimeout(function () {
          if (!dropdown.matches(':hover') && !dropdown.contains(document.activeElement)) close();
        }, 140);
      });
      dropdown.addEventListener('focusin', open);
      dropdown.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!dropdown.contains(document.activeElement) && !dropdown.matches(':hover')) close();
        }, 0);
      });
    });

    document.addEventListener('click', function (event) {
      qsAll('.tm_header-dropdown.active').forEach(function (dropdown) {
        if (dropdown.contains(event.target)) return;
        dropdown.classList.remove('active');
        var trigger = dropdown.querySelector('.user-background');
        var menu = dropdown.querySelector('.my-account');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.style.removeProperty('display');
      });
    });
  }

  function init() {
    updateNavMeasurements();
    bindMegaDropdowns();
    bindAccountMenu();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', updateNavMeasurements);
  window.addEventListener('scroll', updateNavMeasurements, { passive: true });
})();
